

export function message_azure_to_minsait(response_activity, activity) {
    let aux_dict = {}
    if ('text' in activity){
        aux_dict = {}
        if(activity["text"].indexOf("#VALORACION#") >= 0){
            aux_dict["answer"] = ""
            aux_dict["type"] = "rating"
            aux_dict["data"] = []
        }else{
            aux_dict["answer"] = activity["text"]
            aux_dict["type"] = "text"
            aux_dict["data"] = []
        }
        response_activity.push(aux_dict)
    }
    if ('suggestedActions' in activity){
        aux_dict = {}
        aux_dict["answer"] = ""
        aux_dict["type"] = "postback_button"
        aux_dict["data"] = []
        for (let btn of activity['suggestedActions']['actions']){
            
            aux_dict["data"].push({"text":btn["title"], "payload":btn["value"]})
        }
        response_activity.push(aux_dict)
    }
    return response_activity
}